import React from "react";
import StickyHeadTable from "./StickyHeadTable";
import { isMobile } from "react-device-detect";
import { Box, Typography } from "@mui/material";
import dateFormat from "dateformat";
import PageWrapper from "./layout/PageWrapper";

const AdminCategories = (props) => {
  const { superUser, categories, onDelete, onEdit, onRefreshData } = props;

  const [categoriesForSelection, setCategoriesForSelection] = React.useState(
    []
  );

  const handleCategoriesForSelectionChange = (categories) => {
    setCategoriesForSelection(categories);
  };

  const formattedCategories = (categories || []).map((i) => ({
    ...i,
    created: dateFormat(i.created, "mmm dS, H:MM"),
  }));

  const displayedColumns = [
    { id: "id", label: "#", minWidth: 50, align: "left" },
    { id: "title", label: "Catégorie", minWidth: 170 },
    { id: "created", label: "Crée le", minWidth: 60 },
    { id: "action", label: "Actions", minWidth: isMobile ? 90 : 120 },
  ];

  return (
    <PageWrapper>
      <Typography variant="subtitle1">
        Enregistrements: ({categories?.length || 0})
        <Box component="span" sx={{ display: "inline-block", ml: 2 }}>
          {categoriesForSelection.length === 0
            ? `Aucune sélection`
            : categoriesForSelection.length === 1
              ? `1 sélectionné`
              : `${categoriesForSelection.length} sélectionnés`}
        </Box>
      </Typography>

      <StickyHeadTable
        superUser={superUser}
        filters={["id", "title", "description", "published", "platforms"]}
        columns={
          isMobile
            ? displayedColumns.filter(
                (c) => c.id === "title" || c.id === "action"
              )
            : displayedColumns
        }
        data={formattedCategories}
        onDelete={onDelete}
        onEdit={onEdit}
        onCategoriesForSelectionChange={handleCategoriesForSelectionChange}
        onRefreshData={onRefreshData}
        checkboxEnabled={true}
      />
    </PageWrapper>
  );
};

export default AdminCategories;
